export const fieldsetTheme = {
  colorScheme: {
    light: {
      root: {
        background: 'transparent'
      },
      legend: {
        background: 'transparent'
      }
    },
    dark: {
      root: {
        background: 'transparent'
      },
      legend: {
        background: 'transparent'
      }
    }
  }
};
